import { useContext, useState } from 'react'
import { useRouter } from 'next/router'

import {
  GlobalStateContext,
  GlobalDispatchContext,
} from 'context/GlobalContextProvider'
import updateCollection from 'actions/collections/update'

import CollectionsLayout from 'components/CollectionsLayout'
import CollectionOrderableList from 'components/CollectionOrderableList'

import s from './index.module.css'

function CollectionsSlug(props) {
  const router = useRouter()
  const { slug } = router.query
  const dispatch = useContext(GlobalDispatchContext)
  const { collections, account } = useContext(GlobalStateContext)
  const [editingName, setEditingName] = useState(false)
  const [itemsOrder, setItemsOrder] = useState(null)

  const collection = collections.items.find((c) => c.slug === slug)

  if (collections.loaded && !collection) return null

  const handleNameEdit = (e) => {
    e.preventDefault()
    dispatch(
      updateCollection(account.authToken, collection.id, { title: editingName })
    )
    setEditingName(false)
  }

  const handleRemoveItem = (item) => {
    dispatch(
      updateCollection(account.authToken, collection.id, {
        items: [
          {
            boardSlug: item.boardSlug,
            boardType: item.boardType,
            modelSlug: item.modelSlug,
            section: 'portfolio', // todo: may need to not hard-code this
            action: 'delete',
          },
        ],
      })
    )
  }

  const handleUpdateOrder = () => {
    dispatch(
      updateCollection(account.authToken, collection.id, {
        newItems: itemsOrder.map((i) => ({
          boardSlug: i.boardSlug,
          boardType: i.boardType,
          modelSlug: i.modelSlug,
          section: i.section,
          images: i.images.map((p) => ({
            id: p.imageId,
            url: p.url,
            orientation: p.orientation,
          })),
        })),
      })
    )
  }

  const handleSortEnd = ({ oldIndex, newIndex }, e) => {
    if (oldIndex === newIndex) return

    const newItemsOrder = [...itemsOrder]
    newItemsOrder.splice(newIndex, 0, newItemsOrder.splice(oldIndex, 1)[0])
    setItemsOrder(newItemsOrder)

    e.preventDefault()
  }

  const hasItems =
    collection &&
    collection.acfLightbox.items &&
    collection.acfLightbox.items.length > 0

  return (
    <CollectionsLayout {...props}>
      {!collection || collections.isLoading ? (
        <div>Loading...</div>
      ) : (
        <div>
          <div className={s.header}>
            {editingName !== false ? (
              <form onSubmit={handleNameEdit} className={s.form}>
                <input
                  type="text"
                  value={editingName}
                  placeholder={collection.title}
                  className={s.input}
                  onChange={(e) => setEditingName(e.target.value)}
                />
                <input type="submit" value="Update" className={s.formButton} />
                <button
                  type="button"
                  onClick={() => setEditingName(false)}
                  className={s.formButton}
                >
                  Cancel
                </button>
              </form>
            ) : (
              <button
                type="button"
                className={s.title}
                onClick={() => setEditingName(collection.title)}
              >
                {collection.title}{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  className={s.editIcon}
                >
                  <path d="M491.609 73.625l-53.861-53.839c-26.378-26.379-69.076-26.383-95.46-.001L24.91 335.089.329 484.085c-2.675 16.215 11.368 30.261 27.587 27.587l148.995-24.582 315.326-317.378c26.33-26.331 26.581-68.879-.628-96.087zM120.644 302l170.259-169.155 88.251 88.251L210 391.355V350h-48v-48h-41.356zM82.132 458.132l-28.263-28.263 12.14-73.587L84.409 338H126v48h48v41.59l-18.282 18.401-73.586 12.141zm378.985-319.533l-.051.051-.051.051-48.03 48.344-88.03-88.03 48.344-48.03.05-.05.05-.05c9.147-9.146 23.978-9.259 33.236-.001l53.854 53.854c9.878 9.877 9.939 24.549.628 33.861z" />
                </svg>
              </button>
            )}
            {itemsOrder ? (
              <>
                <button
                  type="button"
                  onClick={handleUpdateOrder}
                  className={s.button}
                >
                  Confirm new order
                </button>
                <button
                  type="button"
                  onClick={() => setItemsOrder(null)}
                  className={s.button}
                >
                  Cancel (Reset order)
                </button>
              </>
            ) : (
              <button
                type="button"
                className={s.button}
                onClick={() => setItemsOrder(collection.acfLightbox.items)}
                disabled={!hasItems}
              >
                Edit order
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                  className={s.buttonIcon}
                >
                  <path d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z" />
                </svg>
              </button>
            )}
          </div>

          {collections.error && <p className={s.error}>{collections.error}</p>}

          <div className={s.items}>
            {hasItems ? (
              <CollectionOrderableList
                lockToContainerEdges
                axis="xy"
                distance={5}
                onSortEnd={handleSortEnd}
                items={itemsOrder || collection.acfLightbox.items}
                helperClass={s.items}
                removeItem={itemsOrder ? null : handleRemoveItem}
                collectionSlug={slug}
                disabled={!itemsOrder}
              />
            ) : (
              <p className={s.noItem}>
                No items have been added to this collection
              </p>
            )}
          </div>
        </div>
      )}
    </CollectionsLayout>
  )
}

CollectionsSlug.propTypes = {}
CollectionsSlug.defaultProps = {}

export default CollectionsSlug

// export async function getStaticProps() {
//   return {
//     props: {},
//     revalidate: 60 * 60,
//   }
// }
